class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.inputs = document.querySelectorAll("[data-search-form-input]");
    console.log("All inputs for search")
    // this.inputs.forEach(input => {
    //   console.log(input)
    // })
    this.forms = document.querySelectorAll("[data-search-form]");
    this.wrapper = document.querySelector(".quick-search-wrapper");

    this.closeBtns = document.querySelectorAll(".search-form__close");

    this.lastSearchEl = this.querySelector("a[data-last-search]");

    this.predictiveSearchResults = this.querySelector("[data-predictive-search-results]");

    this.isLoading = false;

    this.setupEventListeners();

  }

  getActiveInput() {
    const activeEl = document.activeElement;
    return Array.from(this.inputs).find(input => activeEl == input);
  }

  setupEventListeners() {

    this.inputs.forEach(input => {
      input.addEventListener('input', () => {
        if (input.value.trim().length) this.isLoading = true;
      });

      input.addEventListener('input', debounce((event) => {
        this.onChange();
      }, 300).bind(this));

      input.addEventListener("click", () => {
        const searchQuery = input.value || "!";
        this.getSearchResults(searchQuery);
      })

      input.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          if (!input.value.trim().length || this.isLoading) {
            event.preventDefault();
            return;
          }
          const firstLink = this.querySelector(".quick-search-secondary-container a[href]:not(.quick-search-secondary-container-show-all)");
          if (firstLink) {
            event.preventDefault();
            window.location.href = firstLink.getAttribute("href");
          }
        }
      });
    });

    this.closeBtns.forEach(closeBtn => {
      closeBtn.addEventListener("click", () => this.close());
    });

    this.wrapper.addEventListener("click", (e) => {
        this.close();
    });
  }

  deactivateMegaMenu() {
    document.querySelectorAll(".mega-menu__dropdown").forEach(item => item.setAttribute("inactive", "true"));
  }

  activeMegaMenu() {
    document.querySelectorAll(".mega-menu__dropdown").forEach(item => item.removeAttribute("inactive"));
  }

  saveCurrentSearch() {
    const currentQuery = this.getQuery();
    if (currentQuery && currentQuery !== "") {
      localStorage.setItem("predictiveSearchLastQuery", currentQuery);
    }
  }

  getLastSearch() {
    return localStorage.getItem("predictiveSearchLastQuery") || null;
  }

  buildLastSearch() {
    this.lastSearchEl = this.querySelector("a[data-last-search");

    if (this.lastSearchEl) {
      const lastSearch = this.getLastSearch();
      // console.log("lastsearch " + lastSearch);
      if (lastSearch) {
        this.lastSearchEl.innerHTML = lastSearch + this.lastSearchEl.innerHTML;
        this.lastSearchEl.setAttribute("data-search-query", lastSearch);
      } else {
        this.lastSearchEl.classList.add("hide");
        // this.querySelector("[data-last-search-container]").classList.add("hide");
      }

      this.lastSearchEl.addEventListener("click", () => {
        this.getSearchResults(lastSearch);
      })
    }
  }

  getQuery() {
    var query = this.getActiveInput().value.trim();
    return query;
  }

  onChange() {
    const searchTerm = this.getQuery();

    // console.log(searchTerm);

    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(searchTerm);
    this.saveCurrentSearch();
  }

  buildSearchEndpoint(q) {
    return `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(q.trim())}&resources[type]=product,collection,article&limit=8&section_id=predictive-search`;
  }

  getSearchResults(searchTerm) {
    const searchEndpoint = this.buildSearchEndpoint(searchTerm);
    // console.log(searchEndpoint);
    this.isLoading = true;
    fetch(searchEndpoint)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-predictive-search-results]').innerHTML;
        this.renderSearchResults(resultsMarkup);
        this.buildLastSearch();
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  renderSearchResults(resultsMarkup) {
    // console.log(this.predictiveSearchResults);
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.open();
  }

  open() {
    this.setAttribute("data-show", true.toString());
    this.closeBtns.forEach(closeBtn => closeBtn.classList.add("is-active"));
    document.querySelector("body").classList.add("hide-overflow");
    this.deactivateMegaMenu();
  }

  close() {
    this.setAttribute("data-show", false.toString());
    this.closeBtns.forEach(closeBtn => closeBtn.classList.remove("is-active"));
    document.querySelector("body").classList.remove("hide-overflow");
    this.activeMegaMenu();
  }

}

customElements.define("predictive-search", PredictiveSearch)
